import { type ReactNode, type MouseEvent } from 'react'
import { TileLinkWrapperTwoPageQRExperiment } from 'experiments/pen-5375_v2_two_page_qr'
import { Tile } from '@mc/design-system'
import Link from 'components/Link'

interface ClassTileWrapperProps {
  children: ReactNode
  clickBehavior: 'watchTrailer' | 'navigate'
  href: string
  onLinkClick: () => void
  onWatchTrailerClick: (e: MouseEvent) => void
  openNewPage: boolean
}

export const ClassTileWrapper = ({
  children,
  clickBehavior,
  onLinkClick,
  openNewPage,
  onWatchTrailerClick,
  href,
}: ClassTileWrapperProps) => {
  if (clickBehavior === 'watchTrailer') {
    return (
      <div className='d-block mc-corners--sm mc-overflow--hidden'>
        <Tile aspectRatio='9x16' onClick={onWatchTrailerClick}>
          {children}
        </Tile>
      </div>
    )
  }

  return (
    <TileLinkWrapperTwoPageQRExperiment
      parentChildren={children}
      control={
        <Link
          className='d-block mc-corners--sm mc-overflow--hidden'
          href={href}
          passHref
          newTab={openNewPage}
          onClick={onLinkClick}
        >
          <Tile aspectRatio='9x16'>{children}</Tile>
        </Link>
      }
    />
  )
}
